
import DashboardLayout from "./DashboardLayout"
import { lazy } from "react"
import { Suspense } from "react"
import { useWallet } from "@solana/wallet-adapter-react"
import AppLoader from "../../components/AppLoader/AppLoader"
import HowToBuy from "./components/HowToBuy/HowToBuy"


const DashboardHeader = lazy(() => import('./components/dashboardHeader/DashboardHeader'))
const DashboardMain = lazy(() => import('./components/dashboardMain/DashboardMain'))
const DashboardReferralsTable = lazy(() => import('./components/DashboardReferralsTable/DashboardReferralsTable'))

export default function DashboardDocuments () {

    const {connected} = useWallet()




return (

  <DashboardLayout>
            <Suspense fallback=
                {
                    <div className='w-full h-full  shadow-xl  rounded-lg border-neutral-500/20 border    bg-yellow-500/10 backdrop-blur p-5'>
                        <AppLoader />
                    </div>
                } >
                {/* <DashboardHeader /> */}
            </Suspense>
            {
                !connected ?
                    <div className='w-full !h-[600px]  flex items-center justify-center shadow-xl text-center rounded-lg border-neutral-500/20 border    bg-black/80 backdrop-blur-lg p-5'>

                        <h1 className="font-logo text-4xl text-neutral-300">Connect Your Wallet ... ¯\_(ツ)_/¯</h1>
                    </div>
                    :
                    <>
                        <Suspense fallback=
                            {
                                <div className='w-full !h-full  shadow-xl  rounded-lg border-neutral-500/20 border    bg-black/80 backdrop-blur-lg p-5'>
                                    <AppLoader />
                                </div>
                            } >
                            < HowToBuy/>
                        </Suspense>
                    </>
            }
        </DashboardLayout>


)






}